import React from 'react';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';
import Recorder from 'components/ui/MediaRecorder';

const WebcamRecordingRepeatableQuestion = props => {
  const {
    data,
    meta,
    disabled,
    handleBadUploadType,
    saveMedia,
    setFinishedRecording,
    setIsTabDisabled,
    setUploadFinished,
    setUploadStarted,
  } = props;
  const { questionId, progressId } = data;
  const { features, apiKey } = meta;

  /**************** WEBCAM FUNCTIONS *******************/

  const recordWebcamEvent = (eventType, token) => {
    if (!token) return;
    setFinishedRecording(false);
    setIsTabDisabled(true);

    const eventTrackingData = {
      browser_information: true,
      event_type: eventType,
      event_data: {
        question_id: questionId,
        progress_id: progressId,
        token,
      },
    };
    request.post(routes.EVENTS, eventTrackingData);
  };

  return (
    <Recorder
      apiKey={apiKey}
      disabled={disabled}
      provider="ziggeo"
      saveMedia={saveMedia}
      recordWebcamEvent={recordWebcamEvent}
      setUploadingComplete={setUploadFinished}
      setUploadStarted={setUploadStarted}
      handleBadUploadType={handleBadUploadType}
      webcamPlaybackEnabled={features.webcamPlayback}
    />
  );
};

export default WebcamRecordingRepeatableQuestion;
